import { FC } from 'react';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { FaIcon } from '../FaIcon';
import { Select, SelectItem } from '../Select';

export type PaginationPageSize = number | 'all';
export type PaginationPageSizeItem = {
  key: PaginationPageSize;
  label: string;
};

type PageSizeSelectProps = {
  label?: string;
  container: HTMLElement;
  items?: PaginationPageSizeItem[];
  onSelect: (pageSize: PaginationPageSize) => void;
  selectedKey: PaginationPageSize;
};

export const DEFAULT_PAGINATION_PAGE_ITEMS: PaginationPageSizeItem[] = [
  { key: 8, label: '8' },
  { key: 16, label: '16' },
  { key: 24, label: '24' },
  { key: 32, label: '32' },
  { key: 40, label: '40' },
  { key: 48, label: '48' },
];

export const PageSizeSelect: FC<PageSizeSelectProps> = ({
  label,
  items = DEFAULT_PAGINATION_PAGE_ITEMS,
  container,
  onSelect,
  selectedKey,
}) => {
  const selectedItem = items.find((item) => item.key === selectedKey);

  const menuItems = items.reduce((acc, item) => {
    if (item.key === 'all') {
      return [
        ...acc,
        [
          {
            value: item.key,
            label: item.label,
          },
        ],
      ];
    }

    return [
      ...acc,
      {
        value: item.key.toString(),
        label: item.label,
      },
    ];
  }, [] as SelectItem[]);

  return (
    <div className="ms-auto flex items-center gap-3">
      <p className="text-body-md" id="page-size-label">
        {label}
      </p>
      <Select
        defaultValue={selectedKey.toString()}
        items={menuItems}
        container={container}
        onSelect={(item) => {
          if (item.toLowerCase() === 'all') {
            onSelect('all');
          } else {
            onSelect(parseInt(item));
          }
        }}
        trigger={
          <button
            type="button"
            className="l-btn l-btn-sm l-btn-tertiary items-center gap-1"
            aria-labelledby="page-size-label"
          >
            <span className="text-title-sm">{selectedItem?.label}</span>
            <FaIcon icon={faChevronDown} width={16} height={16} />
          </button>
        }
      />
    </div>
  );
};
